import { TOKEN_KEY } from '@/config/api'
import LandingPage from '@/pages/auth/LandingPage'
import { useAuth } from '@/contexts/AuthContext'
import { Spin } from 'antd'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { loading } = useAuth()
  const token = localStorage.getItem(TOKEN_KEY)

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" tip="Caricamento..." />
      </div>
    )
  }

  if (!token) {
    return <LandingPage />
  }

  return <>{children}</>
}

export default ProtectedRoute
